
export const terminalEndpoint = 'terminal/'
export const bodyEndpoint = 'body/'
export const worksEndpoint = 'work/'
export const extraWorksEndpoint = 'extraWorks/'
export const infoEndpoint = 'info/'
export const settingEndpoint = 'setting/'
